import { AlertTriangle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAppConfig } from "@/hooks/useAppConfig";

interface EmergencyModeConfig {
  enabled: boolean;
  message?: string | null;
}

export function EmergencyModeBanner() {
  const { data: emergencyMode } = useAppConfig<EmergencyModeConfig>(
    "emergency_mode",
    { enabled: false },
    { refetchInterval: 30000 },
  );

  if (!emergencyMode?.enabled) {
    return null;
  }

  return (
    <div className="bg-amber-600 px-4 py-3 text-white shadow-lg">
      <div className="container mx-auto flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0" />
          <div className="text-sm">
            <p className="font-medium">
              We're currently experiencing an issue on the Cloudflare side. To keep working with
              your crew planning, you can switch to Emergency mode.
            </p>
            <p className="mt-1 text-amber-100">
              For questions, please mail to{" "}
              <a href="mailto:support@produce-app.com" className="font-medium underline">
                support@produce-app.com
              </a>
            </p>
          </div>
        </div>
        <Link to="/settings?tab=emergency">
          <Button
            variant="outline"
            size="sm"
            className="whitespace-nowrap border-white/30 bg-white/10 text-white hover:bg-white/20 hover:text-white"
          >
            Open Emergency mode
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
